(function() {
    "use strict";

    // ---------- CALENDAR STATE ----------
    let currentDate = new Date(2026, 1, 1); // Feb 2026
    let selectedDate = new Date(2026, 1, 11); // default Feb 11
    let selectedTimeSlot = null;
    let availableTimeSlots = ["9:00 AM", "10:00 AM", "11:30 AM", "1:00 PM", "2:30 PM", "4:00 PM", "5:00 PM"];

    // DOM elements
    const step1Panel = document.getElementById('step1Panel');
    const step2Panel = document.getElementById('step2Panel');
    const step1Tab = document.getElementById('step1Tab');
    const step2Tab = document.getElementById('step2Tab');
    const continueBtn = document.getElementById('continueToDetailsBtn');
    const backBtn = document.getElementById('backToCalendarBtn');
    const scheduleBtn = document.getElementById('confirmBookingBtn'); // submit button
    const form = document.getElementById('bookingForm');
    const confirmationBox = document.getElementById('formConfirmationBox');

    // summary fields
    const summaryDate = document.getElementById('summaryDate');
    const summaryTime = document.getElementById('summaryTime');

    // ---------- helper functions ----------
    function formatDateKey(date) {
        const options = { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    }
    function formatDateSummary(date) {
        const options = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    }

    // ---------- render calendar (identical to functional version) ----------
    function renderCalendar(monthDate) {
        const year = monthDate.getFullYear();
        const month = monthDate.getMonth();
        const firstDay = new Date(year, month, 1);
        let startOffset = firstDay.getDay() - 1;
        if (startOffset === -1) startOffset = 6;
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        document.getElementById('displayMonthYear').innerText = `${monthNames[month]} ${year}`;

        let html = '';
        for (let i = 0; i < startOffset; i++) html += `<span class="day-cell empty"></span>`;

        for (let d = 1; d <= daysInMonth; d++) {
            const cellDate = new Date(year, month, d);
            const isSelected = selectedDate && selectedDate.getDate() === d && selectedDate.getMonth() === month && selectedDate.getFullYear() === year;
            const dayOfWeek = cellDate.getDay();
            let isAvailable = false;
            if (dayOfWeek !== 0 && dayOfWeek !== 6) {
                if (!(d === 4 || d === 18)) isAvailable = true;
            }
            let classes = 'day-cell';
            if (isAvailable) classes += ' available';
            if (isSelected) classes += ' selected';
            html += `<span class="${classes}" data-day="${d}" data-month="${month}" data-year="${year}">${d}</span>`;
        }

        const totalCells = Math.ceil((startOffset + daysInMonth) / 7) * 7;
        const remaining = totalCells - (startOffset + daysInMonth);
        for (let i = 0; i < remaining; i++) html += `<span class="day-cell empty"></span>`;

        document.getElementById('daysContainer').innerHTML = html;

        document.querySelectorAll('.day-cell.available').forEach(cell => {
            cell.addEventListener('click', function(e) {
                const day = parseInt(this.dataset.day);
                const month = parseInt(this.dataset.month);
                const year = parseInt(this.dataset.year);
                selectedDate = new Date(year, month, day);
                selectedTimeSlot = null;
                continueBtn.disabled = true;
                renderCalendar(currentDate);
                updateTimeSlotsForDate(selectedDate);
            });
        });
    }

    // ---------- time slots ----------
    function updateTimeSlotsForDate(date) {
        const badge = document.getElementById('badgeDateText');
        badge.innerText = date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
        
        let slotsForDay = [];
        const dayOfMonth = date.getDate();
        if (dayOfMonth % 3 === 0) slotsForDay = ["10:00 AM", "11:30 AM", "2:00 PM", "3:30 PM"];
        else if (dayOfMonth % 5 === 0) slotsForDay = ["9:00 AM", "10:30 AM", "1:00 PM", "4:15 PM"];
        else slotsForDay = [...availableTimeSlots];
        if (dayOfMonth === 11 || dayOfMonth === 12) slotsForDay = ["10:00 AM", "11:30 AM", "1:00 PM", "2:30 PM", "4:00 PM"];
        if (dayOfMonth === 19) slotsForDay = ["11:00 AM", "2:00 PM", "3:00 PM"];

        const container = document.getElementById('slotContainer');
        container.innerHTML = '';
        slotsForDay.forEach(time => {
            const slotBtn = document.createElement('span');
            slotBtn.className = 'time-slot';
            slotBtn.innerText = time;
            slotBtn.addEventListener('click', function() {
                document.querySelectorAll('.time-slot').forEach(el => el.classList.remove('selected-slot'));
                this.classList.add('selected-slot');
                selectedTimeSlot = time;
                continueBtn.disabled = false;  // enable continue to step2
            });
            container.appendChild(slotBtn);
        });
        if (slotsForDay.length === 0) {
            const none = document.createElement('span');
            none.innerText = 'No availability';
            none.style.color = '#667085';
            container.appendChild(none);
        }
    }

    // month navigation
    function changeMonth(delta) {
        currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + delta, 1);
        if (selectedDate.getMonth() !== currentDate.getMonth() || selectedDate.getFullYear() !== currentDate.getFullYear()) {
            selectedDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        }
        renderCalendar(currentDate);
        updateTimeSlotsForDate(selectedDate);
        selectedTimeSlot = null;
        continueBtn.disabled = true;
    }

    // ---------- switch step to details (step2) ----------
    function showStep2() {
        if (!selectedTimeSlot) return; // guard
        // update summary
        summaryDate.innerText = formatDateSummary(selectedDate);
        summaryTime.innerText = `${selectedTimeSlot} ET`;
        // hide step1, show step2
        step1Panel.classList.add('hidden');
        step2Panel.classList.remove('hidden');
        step1Tab.classList.remove('active');
        step2Tab.classList.add('active');
        // hide any old confirmation
        confirmationBox.classList.add('hidden');
    }

    function showStep1() {
        step2Panel.classList.add('hidden');
        step1Panel.classList.remove('hidden');
        step2Tab.classList.remove('active');
        step1Tab.classList.add('active');
    }

    // ---------- handle form submit (prevent actual POST, show confirmation) ----------
    function handleFormSubmit(e) {
        e.preventDefault(); // no page reload

        // basic validation
        const name = document.getElementById('fullName').value.trim();
        const email = document.getElementById('email').value.trim();
        const phone = document.getElementById('phone').value.trim();
        if (!name || !email || !phone) {
            alert('Please fill in all required fields (name, email, phone)');
            return;
        }
        // show confirmation inside step2
        confirmationBox.classList.remove('hidden');
        confirmationBox.innerHTML = `<i class="fas fa-check-circle"></i> Thank you, ${name}! Your 30-min call is confirmed for ${formatDateSummary(selectedDate)} at ${selectedTimeSlot} ET. A calendar invite will be sent to ${email}.`;
        // optionally disable confirm button
        document.getElementById('confirmBookingBtn').disabled = true;
    }

    // ---------- initialize ----------
    window.addEventListener('DOMContentLoaded', function() {
        renderCalendar(currentDate);
        updateTimeSlotsForDate(selectedDate);
        continueBtn.disabled = true;

        // month nav
        document.getElementById('prevMonthBtn').addEventListener('click', function() { changeMonth(-1); });
        document.getElementById('nextMonthBtn').addEventListener('click', function() { changeMonth(1); });

        // continue to details button
        continueBtn.addEventListener('click', showStep2);

        // back button
        backBtn.addEventListener('click', showStep1);

        // form submission
        form.addEventListener('submit', handleFormSubmit);
    });
})();